module.exports = __webpack_public_path__ + "static/media/underline.7b416680.svg";